module.exports = __webpack_public_path__ + "static/media/logo-오스템임플란트@3x.db0f5fd3.png";